import React, { useState } from "react";
import AdminHeading from "../Heading/AdminHeading";
import ListTable from "Components/CommonComponents/ListTable";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { useSelector } from "react-redux";
import GetApiService from "Components/Api/getapiService";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import CustomerTable from "Components/support/customervendor/customer";
import { purchaseListColumns } from "utils/helpers";
import { Icon } from "@iconify/react";
import PageLoader from "Components/PageLoader";
import jsPDF from "jspdf";

const AdminPurchaseEntriesList = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const allStates = useSelector((state) => state);
  const navigate = useNavigate();
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);
  const [searchInput, setSearchInput] = useState("");

  const fetchData = async () => {
    try {
      const data = await apiService.fetchAllRDPurchaseList();
      return data;
    } catch (e) {
      console.log(e);
    }
  };
  const {
    data: RDPurchaseList,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["getRdPurchaseList"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  const handleEditData = (product) => {
    navigate(`/edit_purchase_entry_new/${product?.Id}`);
  };
  const columns = [
    { key: "LotNumber", label: "Lot Number" },
    { key: "Id", label: "RD Purchase Id" },
    { key: "VendorName", label: "Vendor Name" },
    { key: "PurchaseDate", label: "Purchase Date" },
    { key: "InvoiceNo", label: "Invoice No" },
    { key: "PurchaseStatus", label: "Purchase Status" },
    { key: "TotalPurchaseAmount", label: "Total Purchase Amount" },
  ];

   const printAllRDPurchase = async (orders) => {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const startX = 10; // Adjusted startX value for the serial number column
      let startY = 20;
      const lineHeight = 5;
      const margin = 5;
      const serialNumberWidth = 20; // Width for the serial number column
      const columnWidth =
        (pageWidth - startX - serialNumberWidth - 10 * margin) / 10;
  
      doc.setFont("helvetica", "normal");
      // doc.setFontSize(12);
      doc.setFontSize(8);
  
      const generateHeader = () => {
        doc.text("S. No.", startX, startY); // Serial Number
        doc.text("SKU", startX + columnWidth, startY);
        doc.text("Category", startX + 3 * columnWidth - 2, startY);
        doc.text("Lot No", startX + 4 * columnWidth, startY);
        doc.text("Gross Wt", startX + 5 * columnWidth, startY);
        doc.text("Stone Wt", startX + 6 * columnWidth, startY);
        doc.text("Net Wt", startX + 7 * columnWidth, startY);
        doc.text("Clip Wt", startX + 8 * columnWidth, startY);
        doc.text("Tag Wt", startX + 9 * columnWidth, startY);
        doc.text("Lanyard Wt", startX + 10 * columnWidth, startY);
        doc.text("Total Wt", startX + 12 * columnWidth, startY);
        // doc.text("Fine%", startX + 6 * columnWidth, startY);
        // doc.text("Wastge%", startX + 7 * columnWidth, startY);
        // doc.text("Fine Wt", startX + 8 * columnWidth, startY);
        // doc.text("F+W Wt", startX + 9 * columnWidth, startY);
        // doc.text("Total Amount", startX + 10 * columnWidth, startY);
      };
      const totalNetWt = orders.reduce(
        (total, item) => total + (parseFloat(item.NetWt) || 0),
        0
      );
      const totalGrossWt = orders.reduce(
        (total, item) => total + (parseFloat(item.GrossWt) || 0),
        0
      );
      // Generate header on the first page
      generateHeader();
      doc.text(
        `Total Net Wt: ${totalNetWt.toFixed(3)} gm`,
        startX + 5 * columnWidth,
        startY - 10
      );
      doc.text(
        `Total Gross Wt: ${totalGrossWt.toFixed(3)} gm`,
        startX,
        startY - 10
      );
      // Generate orders rows
  
      let y = startY + lineHeight + margin;
      orders.forEach((item, index) => {
        // Check if we need to start a new page
        if (index > 0 && y + lineHeight > pageHeight - margin) {
          doc.addPage();
          startY = 20; // Reset startY for the new page
          // Generate header on each new page
          generateHeader();
          y = startY + lineHeight + margin; // Update y position for the new page
        }
  
        const serialNumber = index + 1;
        doc.text(serialNumber.toString(), startX, y);
        doc.text(
          item.StockKeepingUnit ? item.StockKeepingUnit.toString() : "N/A",
          startX + columnWidth,
          y
        );
        doc.text(
          item.CategoryName ? item.CategoryName.toString().substr(0, 7) : "N/A",
          startX + 3 * columnWidth - 2,
          y
        );
        doc.text(
          item.LotNumber ? item.LotNumber.toString().substr(0, 7) : "N/A",
          startX + 4 * columnWidth,
          y
        );
        doc.text(
          item.GrossWt ? item.GrossWt.toString() : "N/A",
          startX + 5 * columnWidth,
          y
        );
        doc.text(
          item.StoneWt ? item.StoneWt.toString() : "N/A",
          startX + 6 * columnWidth,
          y
        );
        doc.text(
          item.NetWt ? item.NetWt.toString() : "N/A",
          startX + 7 * columnWidth,
          y
        );
        doc.text(
          item.ClipWeight ? item.ClipWeight.toString() : "N/A",
          startX + 8 * columnWidth,
          y
        );
        doc.text(
          item.TagWeight ? item.TagWeight.toString() : "N/A",
          startX + 9 * columnWidth,
          y
        );
        doc.text(
          item.LanyardWeight
            ? parseFloat(item.LanyardWeight).toFixed(3).toString()
            : "N/A",
          startX + 10 * columnWidth,
          y
        );
        doc.text(
          parseFloat(
            parseFloat(item.GrossWt) +
              parseFloat(item.TagWeight) +
              parseFloat(item.LanyardWeight)
            //  +
            // parseFloat(item.PouchWeight) +
            // parseFloat(item.OtherWeight)
          )
            .toFixed(3)
            .toString(),
          startX + 12 * columnWidth,
          y
        );
  
        // doc.text(
        //   item.FinePercent ? item.FinePercent.toString() : "N/A",
        //   startX + 6 * columnWidth,
        //   y
        // );
        // doc.text(
        //   item.WastageWt ? item.WastageWt.toString() : "N/A",
        //   startX + 7 * columnWidth,
        //   y
        // );
        // doc.text(
        //   item.FineWt ? parseFloat(item.FineWt).toFixed(3).toString() : "N/A",
        //   startX + 8 * columnWidth,
        //   y
        // );
        // doc.text(
        //   item.FineWastageWt
        //     ? parseFloat(item.FineWastageWt).toFixed(3).toString()
        //     : "N/A",
        //   startX + 9 * columnWidth,
        //   y
        // );
        // doc.text(
        //   item.TotalItemAmt
        //     ? parseFloat(item.TotalItemAmt).toFixed(3).toString()
        //     : "N/A",
        //   startX + 10 * columnWidth,
        //   y
        // );
  
        y += lineHeight + margin;
      });
  
      // Add page numbers
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.text(`Page ${i} of ${totalPages}`, pageWidth - 50, pageHeight - 10);
      }
  
      // Get PDF orders as Uint8Array
      const pdfData = doc.output();
  
      // Create a new Blob from the PDF data
      const pdfBlob = new Blob([pdfData], { type: "application/pdf" });
  
      // Create a URL from the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
  
      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    };

  const handlePrintRdPurchase = ()=>{
    printAllRDPurchase(RDPurchaseList)
  }
  return (
    <>
      <div>
      {isLoading && <PageLoader />}
        <AdminHeading />
        {loading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <ClipLoader size={50} color={"#123abc"} loading={loading} />
            <p>Loading data...</p>
          </div>
        ) : (
          <>
            <div>
              <ErrorModal
                isOpen={showModal}
                onRequestClose={() => {
                  setShowModal(false); // Close the modal
                  navigate("/adminhome"); // Redirect to /adminhome
                }}
                onReload={() => {}} // Pass reload function
                message={errorMessage}
              />

              <div className="adminMainBodyBox">
                {showError ? (
                  <AlertMessage message={messageToShow} type={messageType} />
                ) : null}
              </div>
            </div>
          </>
        )}
      </div>
      {/* <ListTable
      columns={columns}
      handleEditData={handleEditData}
      data={RDPurchaseList?.length ? [...RDPurchaseList].reverse( ) : []}
      /> */}
      <div>
        <div
          style={{
            display: "flex",
            gap: "20px",
            display: "flex",
            justifyContent: "end",
            background: "#fff",
            padding: "10px 0px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search..."
              style={{ border: "1px solid gray", borderRadius: "0px",
                borderBottomLeftRadius:"8px",
                borderTopLeftRadius:"8px",
               }}
              // className={style["serach-input"]}
            />

            <Icon
              style={{
                fontSize: "20px",
                padding: "7px",
                background: "#0077D4",
                color: "#fff",
                height: "20px",
                width: "20px",
                borderBottomRightRadius:"8px",
                borderTopRightRadius:"8px",
              }}
              icon="mdi:magnify"
            />
          </div>

          <Icon
            style={{
              fontSize: "28px ",
              color: "#0077d4",
              cursor: "pointer",
            }}
            icon="bx:export"
          />

          <button
          // style={{ width: "30%" }}
          // className={style["custom-btn"]}
          onClick={handlePrintRdPurchase}
          >
            <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
            Print
          </button>
          <button
            //  onClick={handlenew}
            onClick={() => navigate("/purchase_entry_new")}
            style={{ margin: 0 }}
            // className={style["custom-btn"]}
          >
            New
            <Icon icon="mdi:plus" width="24" height="24" />
          </button>
        </div>

        <CustomerTable
          columns={purchaseListColumns}
          allCategories={RDPurchaseList?.length ? RDPurchaseList : []}
          handleEditData={(product) =>
            navigate(`/edit_purchase_entry_new/${product?.Id}`)
          }
          searchInput={searchInput}
          setSearchInput={setSearchInput}

          // title={"All Customers"}
        />
      </div>
    </>
  );
};

export default AdminPurchaseEntriesList;
